export default __webpack_public_path__ + "static/media/NoTransactions.da15c00d.svg";